import GraphQLClient from 'ts/GraphQLClient'
import { RepoParams } from 'ts/types'
import { ActualsNewApiResponse, GetActualsNewResponse } from 'ts/types/actuals'
import { GET_ACTUALS } from './graphql/getActuals'

interface ActualsRepoParams {
  year: number
  token: string
}

export default class ActualsRepo {
  private client: GraphQLClient

  constructor({ GRAPHQL_URL, GRAPHQL_API_KEY }: RepoParams) {
    this.client = new GraphQLClient({ url: GRAPHQL_URL, apiKey: GRAPHQL_API_KEY })
  }

  async getActuals(params: ActualsRepoParams): Promise<GetActualsNewResponse> {
    const { year, token } = params

    const response = await this.client.request<ActualsNewApiResponse>({
      query: GET_ACTUALS,
      variables: {
        token,
        year
      }
    })

    return response.getUsageDetailsForUserNew
  }
}
